import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

import Login from '../pages/Login';
import HomeDashboard from '../pages/HomeDashboard';
import ContractorProject from '../pages/ContractorProject';
import ContractorData from '../pages/ContractorData';
import Profile from '../pages/Profile';
import Pin from '../pages/Pin';
import Password from '../pages/Password';
import PaymentReport from '../pages/PaymentReport';
import Log from '../pages/Log';
import Help from '../pages/Help';
import About from '../pages/About';

/**
 * Payment Status Page Component
 */
import PaymentStatus from '../pages/PaymentStatus';
import PaymentPending from '../pages/PaymentStatus/views/PaymentPending';
import PaymentWaiting from '../pages/PaymentStatus/views/PaymentWaiting';
import PaymentProcess from '../pages/PaymentStatus/views/PaymentProcess';
import PaymentMethod from '../pages/PaymentStatus/views/PaymentMethod';

/**
 * Member List Page Component
 */
import Member from '../pages/Member';
import ListMember from '../pages/Member/views/ListMember';
import AddMember from '../pages/Member/views/AddMember';
import PaymentFailed from '../pages/PaymentStatus/views/PaymentFailed';
import PaymentSuccess from '../pages/PaymentStatus/views/PaymentSuccess';
import ForgotPassword from '../pages/ForgotPassword';
import UpdateMember from '../pages/Member/views/UpdateMember';

/**
 * Black List Page Component
 */
import Blacklist from '../pages/Blacklist';
import ListBlacklist from '../pages/Blacklist/views/ListBlacklist';
import HistoryBlacklist from '../pages/Blacklist/views/HistoryBlacklist';

// Local Storage
import useLocalStorage from '../hooks/useLocalStorage';
import CONSTANT from '../constant';

const userProfile = useLocalStorage.get(CONSTANT.APP.USER_PROFILE);

const App = () => {
    const location = useLocation();

    if (userProfile?.is_password_weak && location.pathname !== '/') {
        return <Navigate to="/" replace />;
    }

    return (
        <Routes>
            <Route
                index
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <HomeDashboard />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/proyek-kontraktor"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <ContractorProject />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/data-kontraktor"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <ContractorData />
                    </PrivateRoute>
                )}
            />
            <Route path="/status-pembayaran" element={<PaymentStatus />}>
                <Route
                    index
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentPending />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="menunggu-konfirmasi"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentPending />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="menunggu-pembayaran"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentWaiting />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="proses"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentProcess />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="gagal"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentFailed />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="selesai"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentSuccess />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="bayar/:external_id"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <PaymentMethod />
                        </PrivateRoute>
                    )}
                />
            </Route>
            <Route
                path="/daftar-anggota"
                element={<Member breadcrumb={['Iya Iya']} />}
            >
                <Route
                    index
                    element={(
                        <PrivateRoute allowedRoles={[6]}>
                            <ListMember />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="tambah-anggota"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <AddMember />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="update/:user_id"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <UpdateMember />
                        </PrivateRoute>
                    )}
                />
            </Route>
            <Route path="/blacklist" element={<Blacklist />}>
                <Route
                    index
                    element={(
                        <PrivateRoute allowedRoles={[6]}>
                            <ListBlacklist />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="list"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <ListBlacklist />
                        </PrivateRoute>
                    )}
                />
                <Route
                    path="riwayat"
                    element={(
                        <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                            <HistoryBlacklist />
                        </PrivateRoute>
                    )}
                />
            </Route>
            <Route
                path="/laporan-pembayaran"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <PaymentReport />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/profile"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <Profile />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/password"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <Password />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/pin"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <Pin />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/bantuan"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <Help />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/log"
                element={(
                    <PrivateRoute allowedRoles={[6]}>
                        <Log />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/tentang"
                element={(
                    <PrivateRoute allowedRoles={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}>
                        <About />
                    </PrivateRoute>
                )}
            />
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        </Routes>
    );
};

export default App;
